import { ArelTooltip } from "@arelia-components/ui-atoms/Tooltip";
import { Button } from "@mui/material";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { http } from "src/api/http";
import { CustomerStatus } from "../../../models";
import { Roles } from "@arelia-types/index";
import CloseUserConfirmationDialog from "./CloseUserConfirmationDialog";

type Props = {
  identityId: string;
  status: CustomerStatus;
  role: Roles;
}

export default function CloseUser({ identityId, status, role }: Props) {
  const [dialogOpened, setDialogOpened] = useState(false);
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation({
    mutationFn: () => http(`/api/hq/customers/${identityId}/closed`, {
      method: 'PUT',
    }),
    onSuccess: () => {
      queryClient.invalidateQueries(['useHqCustomerDetails']);
    }
  });

  const handleCLoseConfirm = (isConfirmed: boolean) => {
    if (isConfirmed) {
      mutate();
    }

    setDialogOpened(false);
  }

  let arelToolTip: string = "";
  let buttonDisabled: boolean = false;

  if (status === CustomerStatus.Active && role !== Roles.TestUser) {
    arelToolTip = "Only inactive/registered OR test user can be closed";
    buttonDisabled = true;
  }

  return <>
    <ArelTooltip title={arelToolTip}>
      <span style={{ display: "flex" }}>
        <Button
          size="large"
          variant="contained"
          color="error"
          disabled={isLoading || buttonDisabled}
          onClick={() => setDialogOpened(true)
          }>{isLoading ? 'Closing Account...' : 'Close Account'}</Button>
      </span>
    </ArelTooltip>
    {dialogOpened ? <CloseUserConfirmationDialog
      onClose={handleCLoseConfirm}
    /> : <></>}
  </>
}